"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Observable = void 0;
var Observable = /** @class */ (function () {
    function Observable(source, operator) {
        this.source = source;
        this.operator = operator;
    }
    Observable.prototype.pipe = function (step1) {
        var e_1, _a;
        var nextSteps = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            nextSteps[_i - 1] = arguments[_i];
        }
        var return$;
        return$ = new Observable(this, step1);
        try {
            for (var nextSteps_1 = __values(nextSteps), nextSteps_1_1 = nextSteps_1.next(); !nextSteps_1_1.done; nextSteps_1_1 = nextSteps_1.next()) {
                var step = nextSteps_1_1.value;
                return$ = new Observable(return$, step);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (nextSteps_1_1 && !nextSteps_1_1.done && (_a = nextSteps_1.return)) _a.call(nextSteps_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return return$;
    };
    Observable.prototype.subscribe = function (callback) {
        var _this = this;
        var unsubscribe;
        if ('subscribe' in this.source) {
            unsubscribe = this.source.subscribe(function (value) {
                if (_this.operator != null) {
                    _this.operator(callback)(value);
                }
                else {
                    callback(value);
                }
            });
        }
        else {
            var source_1 = this.source;
            source_1.push(callback);
            return function () {
                source_1.remove(callback);
            };
        }
        return unsubscribe;
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=observable.js.map